import React from 'react';
import { useIntl } from 'react-intl';
import { API, View } from '@gin-betting/core';

import globalMsgs from 'messages';
import UserDevice from 'services/user-device';
import { OddButton } from 'ui-lib';
import { topMarketsVerify } from 'utils';
import useMarket from './useMarket';

import './market.scss';

const { isMobileDefault } = topMarketsVerify;

interface Props {
    marketId: string;
    withStub?: boolean;
    withName: boolean;
}

const MARKET_STUB: Omit<View.Market, 'name'> = {
    id: '',
    priority: 0,
    status: API.MarketStatus.SUSPENDED,
    odds: ['', ''],
    specifiers: [],
    typeId: -999,
    tags: [],
};

const Market: React.FC<Props> = ({ marketId, withStub, withName }) => {
    const { formatMessage } = useIntl();
    const { market: realMarket } = useMarket({ marketId });
    const isMobile = UserDevice.getInstance()?.isDeviceMobile();

    let market =
        realMarket ||
        (withStub
            ? { ...MARKET_STUB, name: formatMessage(globalMsgs.marketWinner) }
            : null);

    if (isMobile && realMarket && !isMobileDefault(realMarket)) {
        market = {
            ...MARKET_STUB,
            name: formatMessage(globalMsgs.marketWinner),
        };
    }

    if (!market) return null;

    const { name, odds } = market;

    return (
        <div styleName="container">
            {withName && (
                <div styleName="name" className="__app-Market-name">
                    <span>{name}</span>
                </div>
            )}
            <div styleName="odds" className="__app-Market-odds">
                {odds.map((oddId, idx) => (
                    <OddButton key={oddId || idx} oddId={oddId} />
                ))}
            </div>
        </div>
    );
};

export default React.memo(Market);
